import { action, makeObservable, observable, runInAction } from "mobx";
import Oidc from "oidc-client";

const SUPER_ADMIN_EMAILS = new Set(["g@randmar.io", "georges@randmar.io", "d@randmar.io", "mia@randmar.io"]);

const config: Oidc.UserManagerSettings = {
  authority: import.meta.env.VITE_AUTHORITY,
  client_id: "js",
  redirect_uri: `${window.location.origin}${import.meta.env.VITE_REDIRECT_URI
    }`,
  response_type: "code",
  response_mode: "query",
  scope: "openid",
  post_logout_redirect_uri: `${window.location.origin}${import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI
    }`
};

export const manager = new Oidc.UserManager(config);
manager.events.addAccessTokenExpired(() => {
  manager.removeUser().then(() => {
    window.location.href = `${import.meta.env.VITE_RANDMAR_HOME}`;
  });
});

export default class UserStore {
  user?: Oidc.User;

  constructor() {
    makeObservable(this, {
      user: observable,
      storeUser: action.bound
    });
  }

  public signIn() {
    const state = window.location.pathname + window.location.search + window.location.hash;
    manager.signinRedirect({ state });
  }

  public signOut() {
    manager.signoutRedirect({ post_logout_redirect_uri: `https://www.randmar.io` })
  }

  public getApplicationName(): string {
    return this.user?.profile.ApplicationName ?? "";
  }

  public getApplicationId(): string {
    return this.user?.profile.ApplicationId ?? "";
  }

  async storeUser(user: Oidc.User) {
    this.user = user;
    localStorage.setItem('access_token', user.access_token);
    await manager.storeUser(user);
  }

  async getUser() {
    const user = await manager.getUser();

    runInAction(() => {
      this.user = user || undefined;
    });

    return user;
  }

  public isAdmin(): boolean {
    return this.getApplicationId() === "2";
  }

  public isSuperAdmin(): boolean {
    return SUPER_ADMIN_EMAILS.has(this.getApplicationName()) && this.isAdmin();
  }
}
